"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithContainer = exports.fromContainer = exports.useContainer = exports.runHooks = exports.createContainer = exports.assertContainer = exports.isContainer = exports.ContainerSymbol = exports.createContext = exports.assertContext = exports.isContext = void 0;
const hook_1 = require("./hook");
const ContextSymbol = Symbol('Context');
const isContext = (input) => {
    return Object.prototype.hasOwnProperty.call(input, ContextSymbol);
};
exports.isContext = isContext;
const assertContext = (input) => {
    if (!(0, exports.isContext)(input)) {
        throw new Error(`Expected Context, but received ${input}`);
    }
};
exports.assertContext = assertContext;
const createContext = (value) => {
    const id = Symbol('ContextID');
    const create = (value) => {
        const use = () => {
            const container = (0, exports.useContainer)();
            return Object.seal({
                get value() {
                    return container.read(Context);
                },
                set value(v) {
                    container.write(Context, v);
                },
            });
        };
        const get = () => {
            const container = (0, exports.useContainer)();
            return container.read(Context);
        };
        const set = (v) => {
            const container = (0, exports.useContainer)();
            container.write(Context, v);
        };
        const assert = () => {
            const value = get();
            if (value === null || value === undefined) {
                throw new Error(`Expected value is not null or undefined, but got: ${value}`);
            }
            return value;
        };
        const Context = {
            id,
            [ContextSymbol]: value,
            create,
            use,
            get,
            set,
            assert,
        };
        return Context;
    };
    return create(value);
};
exports.createContext = createContext;
exports.ContainerSymbol = Symbol('Container');
const isContainer = (input) => {
    return !!(input && input[exports.ContainerSymbol]);
};
exports.isContainer = isContainer;
const assertContainer = (input) => {
    if (!(0, exports.isContainer)(input)) {
        throw new Error(`Expected Context, but received ${input}`);
    }
};
exports.assertContainer = assertContainer;
const createContextMap = (storage) => {
    const contextMap = new Map();
    Object.values(storage).forEach((context) => {
        contextMap.set(context.id, context);
    });
    return contextMap;
};
const createContainer = (ContextStorage = {}) => {
    const contextMap = createContextMap(ContextStorage);
    const read = (context) => {
        const target = contextMap.get(context.id);
        if (target) {
            return target[ContextSymbol];
        }
        return context[ContextSymbol];
    };
    const write = (context, value) => {
        contextMap.set(context.id, context.create(value));
    };
    const container = Object.freeze({
        [exports.ContainerSymbol]: true,
        read,
        write,
    });
    return container;
};
exports.createContainer = createContainer;
const { run, hooks } = (0, hook_1.createHooks)({
    useContainer: () => {
        throw new Error(`Can't call useContainer out of scope, it should be placed on top of the function`);
    },
});
exports.runHooks = run;
exports.useContainer = hooks.useContainer;
const fromContainer = (container) => ({
    useContainer: () => {
        return container;
    },
});
exports.fromContainer = fromContainer;
const runWithContainer = (f, container) => {
    return (0, exports.runHooks)(f, (0, exports.fromContainer)(container));
};
exports.runWithContainer = runWithContainer;
//# sourceMappingURL=context.js.map